import React from 'react';
import { LineChartIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-107">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-brand-card to-brand-bg border border-brand-gold/20 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-108">
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-109" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-110" />

        <LineChartIcon className="w-16 h-16 text-brand-gold mx-auto mb-8 relative z-10" data-id="element-111" />

        <p className="text-xl md:text-2xl text-brand-text leading-relaxed font-medium relative z-10" data-id="element-112">
          En los próximos 7 días, dejarás de mirar nombres de equipos y
          empezarás a mirar ineficiencias de mercado.
        </p>
        <p className="text-lg md:text-xl text-brand-muted mt-6 leading-relaxed relative z-10" data-id="element-113">
          Al aplicar la Ingeniería Inversa, tu tasa de acierto no dependerá del
          azar, sino de tu capacidad para entrar solo en los partidos donde
          tienes la ventaja matemática sobre la casa.
        </p>
      </div>
    </section>;
}